import { HeaderModule } from '../../common/header/header.module';
import { LabelModule } from '../../common/label/label.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { RetryComponent } from '../../../component/common/retry/retry.component';



@NgModule({
  declarations: [RetryComponent],
  exports: [RetryComponent],
  imports: [
    IonicModule,
    CommonModule,
    HeaderModule,
    LabelModule,
  ]
})
export class RetryModule { }
